import { Component, OnInit, Input, Self, Optional, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import * as uuid from 'uuid';

@Component({
    selector: 'app-form-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
})
export class FormCheckboxComponent implements OnInit, ControlValueAccessor {
    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    public _value: any;

    @Input() disabled: boolean;

    /** Optional helper text rendered as a subtitle under the checkbox label. */
    @Input() subtitle: string;

    @Input() validation = true;

    @Input() showMessages = true;

    @Input() isChecked = false;

    @Input() displayTouchedStyle = true;

    @Output('change') changeOutput = new EventEmitter<any>();

    @ViewChild('input', { static: true }) input;

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(e): void {
        this.value = !!e.target.checked;
    }

    get invalid(): boolean {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid(): boolean {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine(): boolean {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty(): boolean {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched(): boolean {
        if (this.ngControl && this.displayTouchedStyle) {
            return this.ngControl.touched;
        }
        return false;
    }

    writeValue(value: any): void {
        this._value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
